import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'
export const AgendamentoRelatorioList = (props) => <DefaultDataTable data={props} />
